// import { updateField } from 'vuex-map-fields'

const SET_INTERIM_SCHEDULE_REQUEST = (state, payload) => {
  state.interimRequest = payload
}

export default {
  SET_INTERIM_SCHEDULE_REQUEST
}
